import { styled } from '@mui/material/styles'

export const ViewLayout = styled('div')(({ theme: { breakpoints, spacing } }) => ({
  flex: 1,
  display: 'grid',
  gap: spacing(3),
  padding: spacing(3),
  gridTemplateAreas: `
        "title"
        "info"
        "side-function"
        "form"
        `,
  [breakpoints.up('md')]: {
    marginTop: spacing(3),
    marginBottom: spacing(3),
    gridTemplateAreas: `
            "logo title brand"
            ". info side-function"
            ". form ."
          `,
    gridTemplateColumns: '200px 1fr 480px',
    padding: 0
  }
}))

export const EditLayout = styled(ViewLayout)(({ theme: { breakpoints } }) => ({
  gridTemplateAreas: `
        "title"
        "info"
        "side-function"
        "form"
        `,
  [breakpoints.up('md')]: {
    gridTemplateAreas: `
            "logo title brand"
            ". info side-function"
            ". form ."
          `
  }
}))
